import { logInfo } from '@core/logging';
import { GuestSpeakerStreamState } from './state';
/**
 *
 */
export function createGuestSpeakerActions(set, get) {
    return {
        cameraEnabledStateToggled: () => {
            set((prevState) => {
                return {
                    streamControls: {
                        ...prevState.streamControls,
                        cameraEnabled: !prevState.streamControls.cameraEnabled,
                    },
                };
            }, false, 'cameraEnabledToggled');
        },
        microphoneMutedStateToggled: () => {
            set((prevState) => {
                return {
                    streamControls: {
                        ...prevState.streamControls,
                        microphoneMuted: !prevState.streamControls.microphoneMuted,
                    },
                };
            }, false, 'microphoneMutedStateToggled');
        },
        inviteDismissed: () => {
            if (get().streamState !== GuestSpeakerStreamState.INVITE_RECEIVED) {
                logInfo('You can only dismiss an invitation that was received but not yet accepted.');
                return;
            }
            set({
                streamState: GuestSpeakerStreamState.NO_INVITE,
            }, false, 'inviteDismissed');
        },
        inviteAccepted: () => {
            if (get().streamState !== GuestSpeakerStreamState.INVITE_RECEIVED) {
                logInfo('You must receive an invitation before accepting it.');
                return;
            }
            set({
                streamState: GuestSpeakerStreamState.INVITE_ACCEPTED,
            }, false, 'inviteAccepted');
        },
        inviteCancelled: () => {
            if (get().streamState !== GuestSpeakerStreamState.INVITE_ACCEPTED) {
                logInfo('You must accept an invitation before cancelling it.');
                return;
            }
            set({
                streamState: GuestSpeakerStreamState.INVITE_RECEIVED,
            }, false, 'inviteCancelled');
        },
        inviteDetected: () => {
            if (get().streamState !== GuestSpeakerStreamState.NO_INVITE) {
                logInfo('You must dismiss the existing invitation before receiving a new one');
                return;
            }
            set({
                streamState: GuestSpeakerStreamState.INVITE_RECEIVED,
            }, false, 'inviteDetected');
        },
        streamerReady: () => {
            if (get().streamState !== GuestSpeakerStreamState.INVITE_ACCEPTED) {
                logInfo('You must accept the invitation before getting ready');
                return;
            }
            set({ streamState: GuestSpeakerStreamState.READY_TO_STREAM }, false, 'streamerReady');
        },
        streamerUnready: () => {
            if (get().streamState !== GuestSpeakerStreamState.READY_TO_STREAM) {
                logInfo('You must get ready to stream before you can become unready');
                return;
            }
            set({ streamState: GuestSpeakerStreamState.INVITE_ACCEPTED }, false, 'streamerUnready');
        },
        streamStarted: ({ token, liveStreamId, }) => {
            if (get().streamState !== GuestSpeakerStreamState.READY_TO_STREAM) {
                logInfo('You must get ready to stream before starting the stream');
                return;
            }
            set((prevState) => ({
                streamState: GuestSpeakerStreamState.STREAMING,
                hostTokens: {
                    ...prevState.hostTokens,
                    [liveStreamId]: token,
                },
            }), false, 'streamStarted');
        },
        // Update the stream state to READY_TO_STREAM and revoke the existing host
        // token.
        broughtOffAir: (liveStreamId) => {
            if (get().streamState !== GuestSpeakerStreamState.STREAMING) {
                logInfo('You must be streaming before the stream can be brought off air');
                return;
            }
            set((prevState) => {
                const newHostTokens = {
                    ...prevState.hostTokens,
                };
                delete newHostTokens[liveStreamId];
                return {
                    streamState: GuestSpeakerStreamState.READY_TO_STREAM,
                    hostTokens: newHostTokens,
                };
            }, false, 'streamEnded');
        },
        // Set the stream state to NO_INVITE and revoke the existing host token.
        // Note that this action forces the stream state to change and will update
        // the stream state regardless of the current stream state.
        removedFromStream: (liveStreamId) => {
            set((prevState) => {
                const newHostTokens = {
                    ...prevState.hostTokens,
                };
                delete newHostTokens[liveStreamId];
                return {
                    streamState: GuestSpeakerStreamState.NO_INVITE,
                    hostTokens: newHostTokens,
                };
            }, false, 'removedFromStream');
        },
    };
}
